<template>
    <span v-if="tags">
        <span
            class="badge badge-pill small mr-1"
            v-for="(tag, index) in tags_list"
            :class="'badge-'+tag.color "
            :key="index"
        >{{tag.tag}}</span>
    </span>
</template>
<script>

import { mapGetters } from 'vuex';

export default {
    name: 'TagPills',
    props: ['tags'],
    data() {
        return {
            localValue: [],
        }
    },
    created() {

    },
    computed: {
        ...mapGetters('tags', { findTagsInStore: 'find' }),
        tags_list() {
            return this.findTagsInStore({ query: { _id: { $in: this.tags } } }).data;
        },

    },
}
</script>